import StackTrace from 'stacktrace-js';

export default $ => {
  window.onerror = (message, file, line, column, error) => {
    const callback = stackframes => {
      const stack = stackframes.map(stackframe => stackframe.toString()).join(`\n`);
      $.ajax({
        method: 'POST',
        url: Routing.generate('error_logger'),
        data: {
          message,
          file,
          line,
          column,
          stack,
        },
      });
    };

    (error ? StackTrace.fromError(error) : StackTrace.get()).then(callback);
  };
};



// WEBPACK FOOTER //
// ./assets/js/component/error-handler.js